/**
 * Constants for Supabase table names
 * This file serves as the single source of truth for table names
 * used across the application when interacting with Supabase
 */

export const TABLES = {
  // Reference tables
  REFERENCE_CONSTRUCTION_TYPES: 'reference_construction_types',
  REFERENCE_PROJECT_PHASES: 'reference_project_phases',
  REFERENCE_VENDOR_TYPES: 'reference_vendor_types',
  REFERENCE_COST_TYPES: 'reference_cost_types',
  REFERENCE_HOME_CHOICE_ITEMS: 'reference_home_choice_items',
  REFERENCE_ITEM_TYPES: 'reference_item_types',
  REFERENCE_PAYMENT_SCHEDULE_TYPES: 'reference_payment_schedule_types',
  REFERENCE_ROLES: 'reference_roles',
  REFERENCE_SUGGESTED_ITEMS: 'reference_suggested_items',
  REFERENCE_BOQ_CATEGORIES: 'reference_boq_categories', // Used by template system (BOQSetup)
  REFERENCE_BB_CHAPTERS: 'reference_bb_chapters',
  REFERENCE_BOQ_NOTES: 'reference_boq_notes',
  ARCHITECT_BOQ_NOTES: 'architect_boq_notes',
  PROJECT_BOQ_NOTES: 'project_boq_notes',

  // Master tables
  MASTER_SPACES: 'master_spaces',
  MASTER_ITEMS: 'master_items',
  MASTER_VENDORS: 'master_vendors',
  MASTER_BOQ_TEMPLATE_ITEMS: 'master_boq_template_items',

  // Project tables
  PROJECT_INFO: 'project_info',
  PROJECT_SPACES: 'project_spaces',
  PROJECT_ITEMS: 'project_items',
  PROJECT_PAYMENTS: 'project_payments',
  PROJECT_FLOORS: 'project_floors',
  PROJECT_WINDOWS: 'project_windows',
  PROJECT_VENDORS: 'project_vendors',
  PROJECT_VENDOR_TYPE_ASSIGNMENTS: 'project_vendor_type_assignments',
  PROJECT_BOQ_TEMPLATE_STATUS: 'project_boq_template_status', // Template system
  PROJECT_DEFAULT_OPTIONS: 'project_default_options',
  DRAFT_PROJECT_BOQ_ITEMS: 'draft_project_boq_items', // Template system
  USER_PROFILES: 'user_profiles',

  // Vendor Quote tables
  VENDOR_QUOTES: 'vendor_quotes',
  VENDOR_QUOTE_ITEMS: 'vendor_quote_items',

  // Join tables
  JOIN_PROJECT_USERS: 'join_project_users',
  JOIN_CONSTRUCTION_ITEM_TYPES: 'join_construction_item_types',
};

// Construction item type IDs — used to distinguish construction items from כללי items
// Both have space_id = NULL, but construction items have these item_type_ids on their master_items
export const CONSTRUCTION_TYPE_IDS = [
  '298b255e-c284-4693-a8d7-7aeaad5444b4', // פינוי והריסה
  '428b4691-77f3-4eda-b578-4d1395fbd657', // בנייה כללית
  '91996708-cdbd-4db0-9073-28ac9db0b088', // שלד וקירות פנים
  '160f08e3-f2a2-4242-a584-2266c7b8dbb5', // בטון ופלדה
];
